import { render, staticRenderFns } from "./welcomeScreen.vue?vue&type=template&id=4edb5d92&scoped=true"
import script from "./welcomeScreen.vue?vue&type=script&lang=js"
export * from "./welcomeScreen.vue?vue&type=script&lang=js"
import style0 from "./welcomeScreen.vue?vue&type=style&index=0&id=4edb5d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edb5d92",
  null
  
)

export default component.exports